<script>
  import Graph from "../../shared/Graph.svelte";
  import Matrix from "../../shared/Matrix.svelte";
  import data1 from "../../stores/Graph_L5_1.js";
  import { _ } from "svelte-i18n";

  const matrix1 = [
    [1, 0, 0, 0],
    [0, 1, 0, 0],
    [0, 0, 0, 1],
    [0, 0, 1, 0],
  ]
</script>

<div class="title">
  <h2>{$_("lesson-yV8O6.h2-0")}</h2>
</div>
<hr />
<div class="text">
  <p>
    {$_("lesson-yV8O6.p-0")}
  </p>
  <p>
    {$_("lesson-yV8O6.p-1")}
  </p>
  <Graph graph={data1} width="500" height="350" style="display: block; margin: 0 auto;"/>
  <p>
    {@html $_("lesson-yV8O6.p-2")}
  </p>
  <h3>{$_("lesson-yV8O6.h3-0")}</h3>
  <p>
    {$_("lesson-yV8O6.p-3")}
  </p>
  <ol>
    <li>{$_("lesson-yV8O6.li-0")}</li>
    <li>{$_("lesson-yV8O6.li-1")}</li>
  </ol>
  <p>
    {$_("lesson-yV8O6.p-4")}
  </p>
  <Matrix size="300" data={matrix1} showLabels={true}/>
  <p>
    {@html $_("lesson-yV8O6.p-5")}
  </p>
  <p>
    {@html $_("lesson-yV8O6.p-6")}
  </p>
</div>

<style>
  .title h2 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
</style>
